import { SVGProps } from 'react';

export const OpenInNewWindowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.5 2L14 2C14.1326 2 14.2598 2.05268 14.3536 2.14645C14.4473 2.24021 14.5 2.36739 14.5 2.5V6C14.5 6.27614 14.2761 6.5 14 6.5C13.7239 6.5 13.5 6.27614 13.5 6V3.70711L5.35355 11.8536C5.15829 12.0488 4.84171 12.0488 4.64645 11.8536C4.45118 11.6583 4.45118 11.3417 4.64645 11.1464L12.7929 3L10.5 3C10.2239 3 10 2.77614 10 2.5C10 2.22386 10.2239 2 10.5 2ZM3.5 5C2.94772 5 2.5 5.44772 2.5 6V13C2.5 13.5523 2.94772 14 3.5 14H10.5C11.0523 14 11.5 13.5523 11.5 13V7.5C11.5 7.22386 11.7239 7 12 7C12.2761 7 12.5 7.22386 12.5 7.5V13C12.5 14.1046 11.6046 15 10.5 15H3.5C2.39543 15 1.5 14.1046 1.5 13V6C1.5 4.89543 2.39543 4 3.5 4H9C9.27614 4 9.5 4.22386 9.5 4.5C9.5 4.77614 9.27614 5 9 5H3.5Z'
      fill='white'
    />
  </svg>
);
